export type PriceDisplay = "both" | "list" | "event" | "none";

export const PRICE_DISPLAYS: PriceDisplay[] = ["both", "list", "event", "none"];

/** Key for the price label when no booking languages are configured. */
export const DEFAULT_PRICE_LABEL_KEY = "default";

/** The label in the visitor's language, else in the original language, else whichever one is filled in. */
export function getPriceLabel(
  labels: Record<string, string> | null | undefined,
  locale?: string | null,
  sourceLocale?: string | null
): string | null {
  if (!labels) return null;
  const pick = (key?: string | null) => (key && labels[key]?.trim()) || null;
  return (
    pick(locale) ??
    pick(sourceLocale) ??
    Object.values(labels)
      .map((label) => label.trim())
      .find(Boolean) ??
    null
  );
}

/** No setting means the price shows in both places. */
export const showsPriceIn = (display: PriceDisplay | null | undefined, place: "list" | "event") =>
  (display ?? "both") === "both" || display === place;

/** An Ant Design icon (https://ant.design/components/icon) by its export name, and its color. */
export type PriceIcon = { name: string; color: string };

export const DEFAULT_PRICE_ICON: PriceIcon = { name: "EuroCircleTwoTone", color: "#eb2f96" };

export const isPriceIconName = (name: string) =>
  /^[A-Z][A-Za-z0-9]{0,60}(Outlined|Filled|TwoTone)$/.test(name);

export const isPriceIconColor = (color: string) => /^#[0-9a-fA-F]{6}$/.test(color);

/** Served by /api/price-icon, which answers 404 for a name Ant Design does not have. */
export function getPriceIconUrl(icon?: PriceIcon | null): string {
  const { name, color } = icon ?? DEFAULT_PRICE_ICON;
  return `/api/price-icon?name=${encodeURIComponent(name)}&color=${encodeURIComponent(color)}`;
}
